import { createActionGroup, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  StoreAvailableAdjustmentRequestListContent,
  StoreAvailableAdjustmentRequestSearchCriteria
} from '../../model/store-available-adjustment-request.model';

export const StoreAvailableAdjustmentRequestAction = createActionGroup({
  source: 'Store Available Adjustment Request',
  events: {
    RequestList: props<{ criteriaObj: StoreAvailableAdjustmentRequestSearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<StoreAvailableAdjustmentRequestListContent>;
    }>()
  }
});
